module.exports = __webpack_public_path__ + "img/eye-open.svg";